/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Equipment_Group_Body_WeightInputs */

const en_us2_equipment_group_body_weight = /** @type {(inputs: Equipment_Group_Body_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Body weight`)
};

const pt_br2_equipment_group_body_weight = /** @type {(inputs: Equipment_Group_Body_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso do corpo`)
};

const es_419_equipment_group_body_weight = /** @type {(inputs: Equipment_Group_Body_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso corporal`)
};

const pt_pt2_equipment_group_body_weight = /** @type {(inputs: Equipment_Group_Body_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso corporal`)
};

const fr_fr2_equipment_group_body_weight = /** @type {(inputs: Equipment_Group_Body_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poids du corps`)
};

const de_de2_equipment_group_body_weight = /** @type {(inputs: Equipment_Group_Body_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Körpergewicht`)
};

const it_it2_equipment_group_body_weight = /** @type {(inputs: Equipment_Group_Body_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corpo libero`)
};

/**
* | output |
* | --- |
* | "Body weight" |
*
* @param {Equipment_Group_Body_WeightInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const equipment_group_body_weight = /** @type {((inputs?: Equipment_Group_Body_WeightInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Equipment_Group_Body_WeightInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_equipment_group_body_weight(inputs)
	if (locale === "es-419") return es_419_equipment_group_body_weight(inputs)
	if (locale === "pt-PT") return pt_pt2_equipment_group_body_weight(inputs)
	if (locale === "fr-FR") return fr_fr2_equipment_group_body_weight(inputs)
	if (locale === "de-DE") return de_de2_equipment_group_body_weight(inputs)
	if (locale === "it-IT") return it_it2_equipment_group_body_weight(inputs)
	return en_us2_equipment_group_body_weight(inputs)
});
export { equipment_group_body_weight as "equipment.group.body_weight" }